import { render, staticRenderFns } from "./CurriculumForm.vue?vue&type=template&id=59b22b77&scoped=true&lang=pug"
import script from "./CurriculumForm.vue?vue&type=script&lang=js"
export * from "./CurriculumForm.vue?vue&type=script&lang=js"
import style0 from "./CurriculumForm.vue?vue&type=style&index=0&id=59b22b77&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59b22b77",
  null
  
)

export default component.exports